import { Box } from '@mui/material'
import {
  Globe20Regular,
  Phone20Regular,
  PlugConnected20Regular,
  Rss20Regular,
} from '@/components/Icon'
import { GmailIcon16, OutlookIcon16 } from '@/components/Icon/MailProviderIcons'
import styles from './index.module.scss'

export function WorkflowAppFallbackIcon({ pillKind }) {
  const kind = String(pillKind || '').toLowerCase()
  const iconClass = styles.fallbackIcon
  if (kind === 'gmail') return <GmailIcon16 className={iconClass} />
  if (kind === 'outlook') return <OutlookIcon16 className={iconClass} />
  if (kind === 'phone') return <Phone20Regular className={iconClass} />
  if (kind === 'rss') return <Rss20Regular className={iconClass} />
  if (kind === 'plug') return <PlugConnected20Regular className={iconClass} />
  return (
    <Box className={styles.fallbackGlobeWrap}>
      <Globe20Regular className={iconClass} />
    </Box>
  )
}
